import toast from "bootstrap/js/src/toast";
import {getFrontendBase, showErrorMessage} from '@/helper';
import {setToken} from '@/services/AuthService';

export default {
    getConfig() {
        return new Promise((resolve, reject) => {
            http.get('api/clients/config').then(response => {
                resolve(response.data);
            }).catch(() => {
                reject({ visible_fields: { FO: [], PO: [] } });
            });
        });
    },

    fetchRecords(body) {
        return new Promise((resolve, reject) => {
            http.post('api/clients/list', {
                page: body.page,
                search: body.search,
                length: body.pageLength,
                order: [{'column': body.orderColumn, 'dir': body.orderAsc ? 'asc' : 'desc'}],
                filter: body.filter
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getAll(style = 'default') {
        return new Promise((resolve, reject) => {
            http.get('api/clients' + (style ? '?style=' + style : '')).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getClient(id, style = null) {
        return new Promise((resolve, reject) => {
            http.get('api/clients/' + id + (style ? '?style=' + style : '')).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getPaymentTerms(id, style = null) {
        return new Promise((resolve, reject) => {
            http.get('api/clients/' + id + '/payment-terms').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    impersonate(id) {
        return new Promise((resolve, reject) => {
            http.get('api/clients/' + id + '/impersonate').then(response => {
                // Token ukládáme jako impersonaci (sessionStorage) - platí jen pro tento
                // panel, takže nepřepíše přihlášení back-office uživatele v ostatních
                // otevřených panelech stejného prohlížeče.
                setToken(response.data.token, {impersonate: true});
                window.location.href = getFrontendBase();
                setTimeout(function() {
                    window.location.reload();
                }, 500);
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    saveClient(data, clientId = null) {
        return new Promise((resolve, reject) => {
            http.post('api/clients' + (clientId ? '/' + clientId : ''), data).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error.response.data.message) {
                    showErrorMessage(error.response.data.message);
                    reject([]);
                } else {
                    reject([]);
                }
            });
        });
    },

    saveClientComplex(data, clientId) {
        return new Promise((resolve, reject) => {
            http.post('api/clients/' + clientId + '/save-complex', data).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error.response?.data?.message) {
                    showErrorMessage(error.response.data.message);
                }
                reject([]);
            });
        });
    },

    saveClientAddress(data, clientId, addressId = null) {
        return new Promise((resolve, reject) => {
            http.post('api/clients/' + clientId + '/addresses' + (addressId ? '/' + addressId : ''), data).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    saveClientBankAccount(data, clientId, accountId = null) {
        return new Promise((resolve, reject) => {
            http.post('api/clients/' + clientId + '/bank-accounts' + (accountId ? '/' + accountId : ''), data).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    /** Načte kompletní historii dokladů totožnosti klienta. */
    getClientIdCards(clientId) {
        return new Promise((resolve, reject) => {
            http.get('api/clients/' + clientId + '/id-cards').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    /**
     * Uloží doklad totožnosti. Pokud je idCardId null, vytvoří nový záznam.
     * Pokud je idCardId vyplněno, aktualizuje existující záznam (POST na /{idCardId}).
     */
    saveClientIdCard(data, clientId, idCardId = null) {
        return new Promise((resolve, reject) => {
            const url = 'api/clients/' + clientId + '/id-cards' + (idCardId ? '/' + idCardId : '');
            http.post(url, data).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    sendInvitation(clientId) {
        return new Promise((resolve, reject) => {
            http.get('api/clients/' + clientId + '/invite').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    sendPaymentTerms(clientId) {
        return new Promise((resolve, reject) => {
            http.get('api/clients/' + clientId + '/send-payment-terms').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    deleteClient(clientId) {
        return new Promise((resolve, reject) => {
            http.delete('api/clients/' + clientId).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    /** Archivuje klienta (soft delete) — pouze SUPERADMIN. */
    archiveClient(clientId) {
        return new Promise((resolve, reject) => {
            http.delete('api/clients/' + clientId).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    /** Obnoví archivovaného klienta — pouze SUPERADMIN. */
    restoreClient(clientId) {
        return new Promise((resolve, reject) => {
            http.post('api/clients/' + clientId + '/restore').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    /** Načte stránkovaný seznam archivovaných klientů — pouze SUPERADMIN. */
    fetchArchivedRecords(body) {
        return new Promise((resolve, reject) => {
            http.post('api/clients/archived/list', {
                page: body.page,
                search: body.search,
                length: body.pageLength,
                order: [{'column': body.orderColumn, 'dir': body.orderAsc ? 'asc' : 'desc'}],
                filter: body.filter
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    deleteAddress(clientId, addressId) {
        return new Promise((resolve, reject) => {
            http.delete('api/clients/' + clientId + '/addresses/' + addressId).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    deleteBankAccount(clientId, accountId) {
        return new Promise((resolve, reject) => {
            http.delete('api/clients/' + clientId + '/bank-accounts/' + accountId).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getClientInvestments(clientId, withTrashed) {
        if(!withTrashed) {
            withTrashed = false;
        }
        return new Promise((resolve, reject) => {
            http.get('api/clients/' + clientId + '/investments'+ (withTrashed ? '?with_trashed=1' : '')).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getAvailableInvestments(clientId, contractId = null) {
        return new Promise((resolve, reject) => {
            http.get('api/strategies?client_id=' + clientId + '&contract_id=' + contractId).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getClientContracts(clientId) {
        return new Promise((resolve, reject) => {
            http.get('api/clients/' + clientId + '/contracts').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },
    getClientContractsv2(clientId, withTrashed) {
        if(!withTrashed) {
            withTrashed = false;
        }
        return new Promise((resolve, reject) => {
            http.get('api/contract/for_client/' + clientId + (withTrashed ? '?with_trashed=1' : '') ).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    saveContract(clientId, data) {
        return new Promise((resolve, reject) => {
            http.post('api/clients/' + clientId + '/contracts' + (data.id ? '/' + data.id : ''), data).then(response => {
                resolve(response.data);
            }).catch(error => {
                // předáme odpověď BE (u 422 obsahuje přeloženou hlášku v `message`),
                // aby volající mohl chybu zobrazit – např. duplicitní typ smlouvy (IMA-523)
                reject(error.response?.data ?? {});
            });
        });
    },

    deleteContract(clientId, contractId) {
        return new Promise((resolve, reject) => {
            http.delete('api/clients/' + clientId + '/contracts/'+ contractId).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    saveInvestments(clientId, data) {
        return new Promise((resolve, reject) => {
            http.post('api/clients/' + clientId + '/investments/add-strategies', data).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    saveInvestment(clientId, data) {
        return new Promise((resolve, reject) => {
            http.post('api/clients/' + clientId + '/investments/' + data.id, data).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    deleteInvestment(clientId, investmentId) {
        return new Promise((resolve, reject) => {
            http.delete('api/clients/' + clientId + '/investments/'+ investmentId).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getAllActiveTemplates(clientId, type, contractId = null) {
        return new Promise((resolve, reject) => {
            // contractId předáme backendu, aby nahradil ${CLIENT_CONTRACT_NUMBER} správnou smlouvou.
            // Bez contractId backend použije první smlouvu klienta jako výchozí.
            let url = 'api/clients/' + clientId + '/forms-templates/active?filter[type]=' + type;
            if (contractId) {
                url += '&contract_id=' + contractId;
            }
            http.get(url).then(response => {
                const data = response.data;
                // Backend vrací { templates: [...], contracts: [...] } pro client-scoped requesty.
                // Fallback na plain array pro zpětnou kompatibilitu (requesty bez client ID).
                resolve(Array.isArray(data) ? { templates: data, contracts: [] } : data);
            }).catch(error => {
                reject({ templates: [], contracts: [] });
            });
        });
    },

    sendAllConceptsToClient(clientId) {
        return new Promise((resolve, reject) => {
            http.get('api/clients/' + clientId + '/send-concepts').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getAllConcepts(clientId) {
        return new Promise((resolve, reject) => {
            http.get('api/clients/' + clientId + '/concepts').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    changeOwner(data, clientId) {
        return new Promise((resolve, reject) => {
            http.post('api/clients/' + clientId + '/change-owner', data).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    changeClientCode(data, clientId) {
        return new Promise((resolve, reject) => {
            http.post('api/clients/' + clientId + '/change-code', data).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    verifyClientSelfRegistration(data, clientId) {
        return new Promise((resolve, reject) => {
            http.post('api/clients/' + clientId + '/verification', data).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error.response.data);
            });
        });
    }
}
